import Api from '../../library/api';

export const REQUEST_SCHEDULED_BOOKINGS = 'REQUEST_SCHEDULED_BOOKINGS';
export const SET_SCHEDULED_BOOKINGS = 'SET_SCHEDULED_BOOKINGS';

export function getScheduledBookings() {
  return dispatch => {

    dispatch({type: REQUEST_SCHEDULED_BOOKINGS});

    Api.post('p/job-summaries', { filter: 'Scheduled' })
      .then(resp => {

        dispatch({
          type: SET_SCHEDULED_BOOKINGS,
          payload: resp.journeyReports
        })

      })

  }
}


// WEBPACK FOOTER //
// ./src/components/scheduled-bookings/scheduled-bookings-actions.js